/* eslint-disable @next/next/no-sync-scripts */
import { bool } from 'prop-types'

const INSTANA_AGENT_KEY = process.env.NEXT_PUBLIC_INSTANA_AGENT_KEY
const AFFIRM_PUBLIC_URL = process.env.NEXT_PUBLIC_AFFIRM_PUBLIC_URL
const AFFIRM_PUBLIC_KEY = process.env.NEXT_PUBLIC_AFFIRM_PUBLIC_KEY

const GTM_KEY = process.env.NEXT_PUBLIC_GTM_KEY || ''
const GTM_AUTH = process.env.NEXT_PUBLIC_GTM_AUTH || ''
const GTM_PREVIEW = process.env.NEXT_PUBLIC_GTM_PREVIEW || ''
const NODE_ENV = process.env.NEXT_PUBLIC_APP_ENV
const GTM_TRACKING_ID = process.env.NEXT_PUBLIC_GTM_TRACKING_ID

const gtmHeadSrc = NODE_ENV === 'production' ? `'https://sgtm.saatva.com/ribeye.js?id='+i+dl` : `'https://sgtm.saatva.com/ribeye.js?id='+i+dl+'&gtm_auth=${GTM_AUTH}&gtm_preview=${GTM_PREVIEW}&gtm_cookies_win=x'`

export default function ThirdPartyScripts({ loadInstana, loadAffirm, loadGTM, loadExtend, loadTrueVault }) {
    return (
        <>
            {loadGTM && GTM_KEY &&
                <script dangerouslySetInnerHTML={{
                    __html: `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
                new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
                j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=${gtmHeadSrc};f.parentNode.insertBefore(j,f);
                })(window,document,'script','dataLayer','${GTM_KEY}');`
                }} />
            }
            {loadInstana && INSTANA_AGENT_KEY && <>
                <script dangerouslySetInnerHTML={{
                    __html: `(function(s,t,a,n){s[t]||(s[t]=a,n=s[a]=function(){n.q.push(arguments)},
                    n.q=[],n.v=2,n.l=1*new Date)})(window,"InstanaEumObject","ineum");

                    ineum('reportingUrl', 'https://eum-red-saas.instana.io');
                    ineum('key', '${INSTANA_AGENT_KEY}' );` }}/>
                <script defer crossOrigin="anonymous" src="https://eum.instana.io/eum.min.js"></script>
            </>}
            {loadAffirm && AFFIRM_PUBLIC_KEY && AFFIRM_PUBLIC_URL &&
                <script dangerouslySetInnerHTML={{
                    __html: `_affirm_config = {
                            public_api_key:  '${AFFIRM_PUBLIC_KEY}',
                            script:          '${AFFIRM_PUBLIC_URL}'
                            };
                            (function(m,g,n,d,a,e,h,c){var b=m[n]||{},k=document.createElement(e),p=document.getElementsByTagName(e)[0],l=function(a,b,c){return function(){a[b]._.push([c,arguments])}};b[d]=l(b,d,"set");var f=b[d];b[a]={};b[a]._=[];f._=[];b._=[];b[a][h]=l(b,a,h);b[c]=function(){b._.push([h,arguments])};a=0;for(c="set add save post open empty reset on off trigger ready setProduct".split(" ");a<c.length;a++)f[c[a]]=l(b,d,c[a]);a=0;for(c=["get","token","url","items"];a<c.length;a++)f[c[a]]=function(){};k.async=
                            !0;k.src=g[e];p.parentNode.insertBefore(k,p);delete g[e];f(g);m[n]=b})(window,_affirm_config,"affirm","checkout","ui","script","ready","jsReady");`
                }}/>
            }
            {loadExtend && process.env.EXTEND_STORE_ID && process.env.EXTEND_ENV &&
                <>
                    <script src="https://sdk.helloextend.com/extend-sdk-client/v1/extend-sdk-client.min.js"></script>
                    <script dangerouslySetInnerHTML={{
                        __html: `Extend.config({ storeId: '${process.env.EXTEND_STORE_ID}', environment: '${process.env.EXTEND_ENV}' })`
                    }} />
                </>
            }
            {loadTrueVault && GTM_TRACKING_ID && <>
                <script dangerouslySetInnerHTML={{
                    __html: `window.polarisOptions={GoogleAnalyticsTrackingId:"${GTM_TRACKING_ID}"}`
                }} />
                <script defer src="https://polaris.truevaultcdn.com/static/pc/OZGXL7OZL/polaris.js" />
            </>}
        </>
    )
}

ThirdPartyScripts.propTypes = {
    loadInstana: bool, 
    loadAffirm: bool,
    loadGTM: bool,
    loadTrueVault: bool
}

ThirdPartyScripts.defaultProps = {
    loadInstana: true, 
    loadAffirm: true,
    loadGTM: true,
    loadTrueVault: true
}
